import React from 'react';
import './Pricing.css';

const plans = [
    {
        name: 'Plan Estándar',
        quote: 'El paso decisivo para optimizar su pilar más importante.',
        description: 'Esta modalidad se enfoca en llevar la eficiencia al máximo en un área clave de su negocio (Servicio al Cliente u Organización/CRM).',
        features: [
            'Agente de IA Funcional Avanzado (Módulo a elegir)',
            'Integraciones Especializadas (CRM, APIs, BD)',
            'Funcionalidades Críticas (Voz, Flujos avanzados)',
            'Entrega Optimizada y Ágil',
        ],
        recommended: 'Empresas que buscan una solución definitiva y de alto impacto para un problema específico.'
    },
    {
        name: 'Plan Automatización Completa',
        quote: 'La transformación 360° que unifica su Front y Back Office.',
        description: 'Implementación de ambos módulos, creando un ecosistema donde la atención al cliente y la gestión interna trabajan como un solo motor.',
        features: [
            'Automatización de Punta a Punta (Ambos módulos)',
            'Flujo de Cliente Sin Fricciones',
            'Mayor Recaptación y optimización de datos',
            'Sinergia Total: El bot alimenta al CRM y viceversa',
        ],
        recommended: 'Empresas que buscan la máxima eficiencia y crecimiento a través de la completa sinergia.'
    },
    {
        name: 'Plan Estratégico y A Medida',
        quote: 'La ruta más segura para una implementación de IA estratégica en toda su organización.',
        description: 'Un servicio integral que comienza con el diagnóstico y culmina con la implementación de agentes en cualquier área (RRHH, Finanzas, etc.).',
        features: [
            'Fase 1: Auditoría Inteligente y Diagnóstico',
            'Fase 2: Hoja de Ruta Personalizada',
            'Fase 3: Implementación a Medida',
            'Alcance Organizacional Total',
        ],
        recommended: 'Empresas que requieren certeza estratégica y una implementación personalizada en cualquier departamento.'
    },
];

const comparison = [
    {
        aspect: 'Nuestro Foco Principal',
        us: 'Mejora Total de Procesos: Somos consultores que organizan y optimizan sus flujos; la IA es la herramienta.',
        them: 'Venta de la Herramienta: Se enfocan en implementar el chatbot o el código sin mejorar los procesos de fondo.',
    },
    {
        aspect: 'La Acción de la IA',
        us: 'La IA Interviene y Soluciona: Ejecuta decisiones (ajusta inventario, envíos) corrigiendo problemas en tiempo real.',
        them: 'La IA Solo Informa y Responde: Se limita a contestar preguntas. No actúa en la operación compleja.',
    },
    {
        aspect: 'Garantía en la Implementación',
        us: 'Conocimiento Interno Asegurado: Basado en técnicas de Mejora Continua para un resultado duradero.',
        them: 'Dependencia Externa: El resultado depende de qué tan bien funciona la herramienta de terceros.',
    },
    {
        aspect: 'Crecimiento Futuro',
        us: 'Escalabilidad Sin Límites: Construida para crecer con usted sin necesidad de rehacer todo desde cero.',
        them: 'Crecimiento Complicado: Difícil y costoso, ya que dependen de las limitaciones de la plataforma inicial.',
    },
];

const Pricing = () => (
    <section className="pricing-section" id="pricing">
        <div className="container">
            {/* --- CABECERA DE PLANES --- */}
            <div className="pricing-header rv in">
                <div className="eyebrow">Planes de Implementación</div>
                <h2 className="s-title">El camino hacia la automatización</h2>
                <p className="s-sub">
                    Hemos diseñado tres caminos estratégicos para llevar la automatización a su empresa.
                    Cada modalidad está pensada para generar un impacto significativo y medible.
                </p>
            </div>

            {/* --- TARJETAS DE PLANES --- */}
            <div className="pricing-grid">
                {plans.map((plan, i) => (
                    <div key={i} className={`pricing-card rv in d${i + 1}`}>
                        <div className="card-top-line"></div>
                        <h3>{plan.name}</h3>
                        <p className="quote">"{plan.quote}"</p>
                        <p className="description">{plan.description}</p>

                        <div className="features-list">
                            {plan.features.map((f, idx) => (
                                <div key={idx} className="feature-item">
                                    <svg viewBox="0 0 12 12" fill="none">
                                        <path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    <span>{f}</span>
                                </div>
                            ))}
                        </div>

                        <div className="recommended-box">
                            <strong>Recomendado para:</strong>
                            <p>{plan.recommended}</p>
                        </div>
                    </div>
                ))}
            </div>

            {/* --- TABLA COMPARATIVA MODERNIZADA --- */}
            <div className="compare-header rv in">
                <div className="eyebrow">Diferencia NAVI</div>
                <h2 className="s-title">NAVI vs. Agencias tradicionales</h2>
            </div>

            <div className="cmp-table-wrapper rv in">
                <div className="cmp-table">
                    <div className="cmp-head-row">
                        <div className="cmp-head">Aspecto Clave</div>
                        <div className="cmp-head navi">
                            <img src="/assets/logo-sin-fondo.webp" alt="NAVI" style={{height: '24px', opacity: 0.9}} />
                            NAVI (Consultores)
                        </div>
                        <div className="cmp-head">Agencias de IA</div>
                    </div>
                    {comparison.map((row, i) => (
                        <div className="cmp-row" key={i}>
                            <div className="cmp-cell feat">{row.aspect}</div>
                            <div className="cmp-cell nc">{row.us}</div>
                            <div className="cmp-cell">{row.them}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default Pricing;